export enum AlertType{
  default,
  userAccess,
}

export default AlertType;
